import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./context/reducer";

const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.REACT_APP_LOCAL === 'true'
})

export { store };